import Cookies from "js-cookie"
import { arrayToMap } from "../../../utils"
import useFetch from "../../../hooks/useFetch"
import useProduct from "../../Shared/useProduct"
import useFetchImplementations from "../../Shared/useFetchImplementations"

export default () => {
  const fetch = useFetch()
  const { fetchProducts: fetchProductsHook } = useProduct()
  const { fetchImplementations: fetchImplementationsHook } = useFetchImplementations()

  const fetchOpportunityOrderDetails = async (opportunityId, isPhysicalLineItemsOnly = true) => {
    try {
      const result = await fetch(`accounts/opportunityOrderDetails?opportunityId=${opportunityId}&isPhysicalLineItemsOnly=${isPhysicalLineItemsOnly}`)
      const resultJson = await result.json()
      return resultJson?.[0]
    } catch (e) {
      console.log(e)
    }
  }

  const fetchProducts = async () => {
    const products = await fetchProductsHook()
    return products || []
  }

  const fetchImplementations = async (accountId) => {
    const response = await fetchImplementationsHook({ accountId })
    return response || []
  }

  const exports = {
    buildOrderTestValues: () => {
      return { 
        accountId: '0015000000uUHFYAA4', // Prosolve
        implementationId: 'a3NJx000003x7gTMAQ', // Y24-8/12 - ProSolve Sales Team 🎓 SLED
        opportunityId: '0060z00001xO3TVAA0', // GaETC (Prosolve)
        products: [
          { id: 14324038, sku: 'SLED-BK', quantity: 1 },
          { id: 14324039, sku: 'QSTAR-BK-S1', quantity: 2 }
        ],
        contactName: 'Bill Tester',
        contactEmail: 'bt@prosolve.com',
        contactPhone: '213-733-7890',
        address: '9521 Cobblestone Street',
        city: 'Pacoima',
        state: 'CA',
        zip: '91331',
        requester: 'Paul Dev'
      }
    },

    buildOrderFromOppBase: async (opportunityId, accountId, oppLineRecFilter) => {
      // TODO should share product data with productDropdown, otherwise we make a call for EACH item type shipped
      const opportunityData = await fetchOpportunityOrderDetails(opportunityId, false)
      const implementationData = await fetchImplementations(opportunityData.Account.Id || accountId)
      const productsData = await fetchProducts()
      //console.log('productsData', productsData)

      const productsDataByName = arrayToMap(productsData, 'reference_id')

      var addressFields = {}
      if (Boolean(opportunityData.Shipping_Street_Address__c)) {
        addressFields = {
          address: opportunityData.Shipping_Street_Address__c,
          city: opportunityData.Shipping_City__c,
          state: opportunityData.Shipping_State__c,
          zip: opportunityData.Shipping_Postal_Code__c,
        }
      } else if (Boolean(opportunityData.Account.ShippingStreet)) {
        addressFields = {
          address: opportunityData.Account.ShippingStreet,
          city: opportunityData.Account.ShippingCity,
          state: opportunityData.Account.ShippingState,
          zip: opportunityData.Account.ShippingPostalCode,
        }
      } else {
        addressFields = {
          address: opportunityData.Account.BillingStreet,
          city: opportunityData.Account.BillingCity,
          state: opportunityData.Account.BillingState,
          zip: opportunityData.Account.BillingPostalCode,
        }
      }

      return { 
        accountId: opportunityData.Account.Id,
        implementationId: (implementationData?.[0]?.Id || undefined),
        opportunityId: opportunityData.Id,
        products: opportunityData.OpportunityLineItems?.records?.filter(oppLineRecFilter).map(o => {
          var productData = productsDataByName[o.PricebookEntry.Product2.Shipbob_SKU_Code__c]
          return {
            name: o.PricebookEntry.Product2.Name, // currently unused, it's recorded here for debugging purposes
            id: productData?.id, // currently unused, it doesn't appear that ShipBob accepts productId
            sku: productData?.reference_id || '',
            quantity: o.Quantity || 1 // should we use Units_Remaining_to_Ship__c instead?
          }
        }) || [],
        companyName: opportunityData.Account?.Name,
        contactName: opportunityData.Account.Shipping_Contact_Name__c,
        contactEmail: opportunityData.Account.Shipping_Contact_Email__c,
        contactPhone: opportunityData.Account.Shipping_Contact_Phone_Number__c,
        ...addressFields,
        shippingType: 'DTC',
        carrierType: 'Parcel',
        requester: Cookies.get('name')
      }
    },

    buildOrderFromOpportunity: async (opportunityId, accountId) => {
      return await exports.buildOrderFromOppBase(opportunityId, accountId, (o) => (o.SKU_Type__c === 'Physical'))
    },

    buildOrderForOpportunityQFC: async (opportunityId, accountId) => {
      return await exports.buildOrderFromOppBase(opportunityId, accountId, (o) => (o.SKU_Type__c === 'Service' && o.PricebookEntry.Product2.Shipbob_SKU_Code__c))
    },

    updateOrderFromContact: (orderInitData, formValues, contact) => {
      return {
        ...orderInitData,
        ...formValues,
        contactName: contact.Name,
        contactEmail: contact.Email,
        contactPhone: contact.Phone,
        address: contact.MailingStreet,
        city: contact.MailingCity,
        state: contact.MailingState,
        zip: contact.MailingPostalCode,
      }
    }
  }

  return exports
}